module.exports = __webpack_public_path__ + "assets/img/jiazai@2x.a338eb3d.png";